// UPSELL: Quick Buy (no redirect) + Show more/less + Cart UI refresh (full file)
(function () {
  if (window.__upsellFullInit) return;
  window.__upsellFullInit = true;

  // ---------- helpers ----------
  function $all(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  async function fetchJson(url, options) {
    const r = await fetch(url, options || {});
    const text = await r.text();
    let data;
    try { data = JSON.parse(text); } catch (e) { data = { raw: text }; }
    if (!r.ok) {
      const msg = (data && (data.description || data.message)) || (data && data.raw) || 'Request failed';
      throw new Error(msg);
    }
    return data;
  }

  async function addVariantToCart(variantId, qty) {
    return fetchJson('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    });
  }

  async function getCart() {
    return fetchJson('/cart.js', { headers: { 'Accept': 'application/json' } });
  }

  function updateCartCount(cart) {
    const count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (count === null) return;

    // самые частые счётчики в темах
    const selectors = [
      '[data-cart-count]',
      '.cart-count',
      '.header__cart-count',
      '.site-header__cart-count',
      '.cart-link__count',
      '.header-cart-count',
      'cart-count'
    ];

    selectors.forEach(sel => {
      $all(sel).forEach(el => { el.textContent = String(count); });
    });
  }

  async function refreshCartDrawerIfPossible() {
    // Пытаемся найти drawer и его section id (если тема работает через sections)
    const drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, [data-cart-drawer], [data-drawer="cart"]');
    if (!drawer) return;

    const sectionId =
      drawer.getAttribute('data-section-id') ||
      (drawer.dataset ? drawer.dataset.sectionId : null) ||
      null;

    if (!sectionId) return;

    // Shopify sections render: получаем HTML секции и пробуем вставить
    const url = `${window.location.pathname}?sections=${encodeURIComponent(sectionId)}`;
    const sections = await fetchJson(url, { headers: { 'Accept': 'application/json' } });
    const html = sections && sections[sectionId];
    if (!html) return;

    // Dawn-style: webcomponent
    if (typeof drawer.renderContents === 'function') {
      drawer.renderContents({ sections: { [sectionId]: html } });
      return;
    }

    // fallback: заменить содержимое drawer
    drawer.innerHTML = html;
  }

  async function refreshCartUI() {
    const cart = await getCart();
    updateCartCount(cart);

    // попытка обновить drawer (если возможно)
    try { await refreshCartDrawerIfPossible(); } catch (e) {}

    // события (некоторые темы слушают)
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

    return cart;
  }

  // ---------- QUICK BUY ----------
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-upsell-quick]');
    if (!btn) return;

    e.preventDefault();

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      alert('Помилка: немає data-variant-id на кнопці.');
      return;
    }

    if (btn.dataset.lock === '1') return;
    btn.dataset.lock = '1';

    const prevText = btn.textContent;
    btn.classList.add('is-loading');
    btn.textContent = 'Додаємо...';

    try {
      await addVariantToCart(variantId, 1);
      await refreshCartUI();

      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.textContent = 'Додано';

      setTimeout(function () {
        btn.textContent = prevText;
        btn.classList.remove('is-added');
        btn.dataset.lock = '0';
      }, 1200);

    } catch (err) {
      console.error(err);
      btn.classList.remove('is-loading');
      btn.textContent = prevText;
      btn.dataset.lock = '0';
      alert('Не вдалося додати в кошик: ' + err.message);
    }
  }, true);

  // ---------- SHOW MORE / SHOW LESS ----------
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-upsell-more]');
    if (!btn) return;

    const root = btn.closest('[data-upsell]');
    if (!root) return;

    e.preventDefault();

    const limit = parseInt(root.getAttribute('data-limit') || '4', 10);
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    const cards = root.querySelectorAll('.upsell-card');

    if (!expanded) {
      cards.forEach(el => el.classList.remove('is-hidden'));
      btn.textContent = 'Показати менше';
      btn.setAttribute('aria-expanded', 'true');
    } else {
      cards.forEach((el, idx) => { if (idx >= limit) el.classList.add('is-hidden'); });
      btn.textContent = 'Показати ще';
      btn.setAttribute('aria-expanded', 'false');
    }
  }, true);

})();
